export { default } from './AccordionSummary';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/AccordionSummary/index.js
// module id = 806
// module chunks = 2